import { ref, onMounted, onUnmounted } from 'vue';

// Global state for simple persistence across components
const deferredPrompt = ref<any>(null);
const isInstallable = ref(false);

const handleBeforeInstallPrompt = (e: Event) => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    deferredPrompt.value = e;
    isInstallable.value = true;
};

const handleAppInstalled = () => {
    isInstallable.value = false;
    deferredPrompt.value = null;
    console.log('PWA was successfully installed');
};

export function usePWAInstall() {
    const promptInstall = async () => {
        if (!deferredPrompt.value) {
            return;
        }
        // Show the install prompt
        deferredPrompt.value.prompt();
        // Wait for the user to respond to the prompt
        const { outcome } = await deferredPrompt.value.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);
        // We've used the prompt, and can't use it again, throw it away
        deferredPrompt.value = null;
        isInstallable.value = false;
    };

    onMounted(() => {
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', handleAppInstalled);
    });

    onUnmounted(() => {
        // Do not remove the handlers on unmount so they persist globally
        // window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        // window.removeEventListener('appinstalled', handleAppInstalled);
    });

    return {
        isInstallable,
        promptInstall
    };
}
